import { gEnums } from 'global/enums/globalEnums'
import _ from 'lodash'
import { convertHelpers } from '../../../common/convert'
import { dataFix } from '../../../common/dataFix'
import { updateLinkHelpers } from '../../../firestoreData/updates/subUpdates/fsUpdate_dataLInks'

const _overrideProps = false
const _inverseMerge = false
const booleanValues = ['yes', 'no', 'maybe'];

export const eventDataHelpers = {
  ammendDataCollectionsFromFieldNames: (data_app, fieldNames) => ammendDataCollectionsFromFieldNames(data_app, fieldNames),
  ammendDataFieldNames: (fieldNames) => ammendDataFieldNames(fieldNames),
  collectTypeFields: (data, matchingArrays) => collectTypeFields(data, matchingArrays),
  collectTypeProps: (mainObject) => collectTypeProps(mainObject),
  convertArrayNamesToKeys: (mainObject) => convertArrayNamesToKeys(mainObject),
  convertTypeKeys: (mainObject, fieldNames) => convertTypeKeys(mainObject, fieldNames),
  createFieldName: (fieldNames, name, fieldName) => createFieldName(fieldNames, name, fieldName),
  getAppDataLinks: (dataCollections) => getAppDataLinks(dataCollections),
  getAppLinks: (documentsData) => getAppLinks(documentsData),
  getDataFromFieldNames: (database_fns, fieldNames) => getDataFromFieldNames(database_fns, fieldNames),
  getMergedDataCollections: (appDataDocuments, dataCollections) => getMergedDataCollections(appDataDocuments, dataCollections),
  getMergedSettings: (appDataDocuments, googleSheetsPreview, gvviSettings, staticViews_app, globalOnly, forUpdate, newIsPriority) => getMergedSettings(appDataDocuments, googleSheetsPreview, gvviSettings, staticViews_app, globalOnly, forUpdate, newIsPriority),
  getPreviewSettings: (projectSettings_gs, gvviSettings, fromCreate) => getPreviewSettings(projectSettings_gs, gvviSettings, fromCreate),
  getPreviousPreviewInfo: (googleSheetsPreview, previousEventSettings, state) => getPreviousPreviewInfo(googleSheetsPreview, previousEventSettings, state),
  getUniqueValues: (database_fns, mainObject, searchProp, propObjName) => getUniqueValues(database_fns, mainObject, searchProp, propObjName),
  normalizeTypeFields: (data, fieldNames) => normalizeTypeFields(data, fieldNames),
  renamePropsInMainObject: (mainObj, existingProps, newProps) => renamePropsInMainObject(mainObj, existingProps, newProps),
}

const ammendDataCollectionsFromFieldNames = (data_app, fieldNames) => {

  _.forEach(data_app, (eventDataItem, eventDataItemKey) => {
    _.forEach(eventDataItem, (dataItem, dataItemKey) => {
      _.forEach(dataItem, (dataItemValue, dataItemPropKey) => {

        // find the corresponding fieldName from the fieldNames object that matches the dataItemPropKey
        const fieldName = findByKey(fieldNames, dataItemPropKey)
        if (fieldName) {

          const { _data, _propKey, _fieldNameKey } = fieldName
          const { formItemType } = _data ?? {}

          let prop_key = _propKey

          if (/firstName/i.test(_propKey)) {
            prop_key = 'firstName';
          }

          // modifiy if lastName
          if (/lastName/i.test(_propKey)) {
            prop_key = 'lastName';
          }

          fieldName._fieldKey = dataItemPropKey;
          delete dataItem[_fieldNameKey];

          switch (formItemType) {
            case gEnums.formItemTypes.dropdown:
              if (!dataItem[prop_key]) {
                dataItem[prop_key] = []
              }
              dataItem[prop_key].push(dataItemValue)
              delete dataItem[dataItemPropKey]
              break;

            case gEnums.formItemTypes.checkbox:
              dataItem[prop_key] = toBoolean(dataItemValue)
              delete dataItem[dataItemPropKey]
              break;

            default:
              // nothing  
              dataItem[prop_key] = dataItemValue
              if (prop_key !== dataItemPropKey) {
                delete dataItem[dataItemPropKey]
              }
          }

        }
      })
    })
  })
}

const createFieldName = (fieldNames, name, fieldName) => {
  fieldNames[name] = {
    label: _.startCase(fieldName),
    type: fieldName,
    _caption: _.startCase(fieldName),
    _data: {
      formItemType: 'dropdown'
    },
    _fieldKey: name,
    _fieldNameKey: name,
    _propKey: fieldName,
  }
}

const getDataFromFieldNames = (database_fns, fieldNames) => {
  const newData = {}
  _.forEach(fieldNames, (fieldName, fieldNameKey) => {
    const { value, _propKey } = fieldName
    if (_.isPlainObject(value)) {
      if (!value['Yes'] && !value['No']) {
        _.forEach(value, (itemValue, itemValueKey) => {
          if (!newData[_propKey]) { newData[_propKey] = {} }
          const docKey = database_fns.get_docKey(true)
          newData[_propKey][itemValueKey] = {
            name: itemValue,
            _initValue: itemValueKey,
            _docKey: docKey
          }
        })
      }
    }
  })
  return newData
};


const ammendDataFieldNames = (fieldNames) => {

  const _fieldNames = {}

  // add a _data object to each fieldName
  _.forEach(fieldNames, (fieldName, fieldNameKey) => {
    const { label, value, type: fieldType } = fieldName

    let _fieldNameKey;
    const altPropKey = _.camelCase(label)

    _fieldNameKey = altPropKey

    fieldName._fieldNameKey = fieldNameKey
    fieldName._propKey = altPropKey
    fieldName._caption = _.startCase(altPropKey)
    fieldName._fieldKey = fieldNameKey

    const isBoolean = _.some(
      _.values(value),
      v => _.isString(v) && _.includes(booleanValues, v.toLowerCase())
    );

    if (_.isObject(value) && !isBoolean) {
      const _altPropKey = altPropKey.toLowerCase().endsWith('type') ? altPropKey + 's' : altPropKey + 'Types';
      _fieldNameKey = _altPropKey
      fieldName._fieldNameKey = fieldNameKey;
      fieldName._propKey = _altPropKey
      fieldName._caption = _.startCase(_altPropKey)
      fieldName._data = {
        dataList: _altPropKey,
        dataListType: gEnums.dataListTypes.dataList,
        formItemType: gEnums.formItemTypes.dropdown
      }
    } else if (isBoolean) {
      fieldName._data = {
        formItemType: gEnums.formItemTypes.checkbox
      }
    } else {
      fieldName._data = {
        formItemType: isBoolean ? gEnums.formItemTypes.checkbox : gEnums.formItemTypes.text
      }
    }
    _fieldNames[_fieldNameKey] = fieldName
  })

  return _fieldNames

}

const getAppLinks = (documentsData) => {
  const appDataLinks = {}
  const _appDataKeys = _.keys(documentsData)
  _.forEach(documentsData, (appData, appDataKey) => {
    const linkData = updateLinkHelpers.get_appLinkedData(null, appDataKey, appData, _appDataKeys)
    if (!_.isEmpty(linkData)) {
      appDataLinks[appDataKey] = linkData[appDataKey]
    }
  })
  return appDataLinks
}

const getAppDataLinks = async (dataCollections) => {

  const _dataCollections = _.cloneDeep(dataCollections);

  const appDataLinks = {};
  const _dataCollectionKeys = _.keys(dataCollections);

  // First Pass: Collect all linked data
  _.forEach(_dataCollections, (dataCollection, dataCollectionKey) => {
    const linkData = updateLinkHelpers.get_appLinkedData(null, dataCollectionKey, dataCollection, _dataCollectionKeys);
    if (!_.isEmpty(linkData)) {
      appDataLinks[dataCollectionKey] = linkData[dataCollectionKey];
    }
  });

  // Second Pass: Ensure reverse relationships are established
  _.forEach(appDataLinks, (appData, appDataKey) => {
    // appDataKey: sessions
    _.forEach(appData, (dataItem, docKey) => { // for each session
      _.forEach(dataItem, (linkedArray, linkedKey) => {  // linkedArray = attendees array, linkedKey = attendees 
        _.forEach(linkedArray, linkedArrayKey => {
          convertHelpers.createNestedObject(appDataLinks, [linkedKey, linkedArrayKey, appDataKey], true)
          convertHelpers.createNestedObject(dataCollections, [linkedKey, linkedArrayKey, appDataKey], true)
          try {
            if (!appDataLinks[linkedKey][linkedArrayKey][appDataKey].includes(docKey)) {
              appDataLinks[linkedKey][linkedArrayKey][appDataKey].push(docKey);
            }
            if (!dataCollections[linkedKey][linkedArrayKey][appDataKey].includes(docKey)) {
              dataCollections[linkedKey][linkedArrayKey][appDataKey].push(docKey);
            }
          } catch (error) {
            console.log('linkedKey', linkedKey, linkedArrayKey, docKey)
          }
        });
      });
    });
  });

  return appDataLinks;

};

/**
 * Merges newItem and existingItem. If inverse = true, newItem will take precedent. If inverse = false, existingItem will take precedent.
 * @param {object} newItem 
 * @param {object} existingItem 
 * @param {boolean} inverse 
 * @returns 
 */
const mergeObjs = (newItem, existingItem, inverse) => {
  if (inverse) {
    return _.merge({}, existingItem, newItem)
  } else {
    return _.merge({}, newItem, existingItem)
  }
}

const mergeObjz = (newItem, existingItem) => {
  const mergeBySchema = (src, schema) => {
    if (!_.isObject(schema) || schema === null) {
      return src !== undefined ? src : schema;
    }

    const result = Array.isArray(schema) ? [] : {};

    for (const key of Object.keys(schema)) {
      // 🚫 drop metadata keys at any level
      if (key.startsWith("_")) continue;

      const schemaVal = schema[key];
      const srcVal = src?.[key];

      if (srcVal === undefined) {
        result[key] = schemaVal;
        continue;
      }

      // recurse for nested objects
      if (_.isObject(schemaVal) && _.isObject(srcVal)) {
        result[key] = mergeBySchema(srcVal, schemaVal);
      } else {
        result[key] = srcVal;
      }
    }

    return result;
  };

  return mergeBySchema(newItem, existingItem);
};
// const mergeObjz = (newItem, existingItem, inverse) => {
//   const base = inverse
//     ? _.merge({}, existingItem, newItem)
//     : _.merge({}, newItem, existingItem);

//   const addedOnly = inverse
//     ? getAddedOnly(newItem, existingItem)
//     : getAddedOnly(newItem, existingItem);
//   console.log('addedOnly', addedOnly)
//   return addedOnly;
// };

const getAddedOnly = (newObj, oldObj) => {
  if (!_.isObject(newObj) || newObj === null) return undefined;

  if (_.isArray(newObj)) {
    // optional: treat arrays as replace or diff (here: replace only if new)
    return undefined;
  }

  const result = {};

  for (const key of Object.keys(newObj)) {
    const newVal = newObj[key];
    const oldVal = oldObj?.[key];

    // key does not exist at all → include full subtree
    if (!_.has(oldObj, key)) {
      result[key] = newVal;
      continue;
    }

    // both are objects → recurse
    if (_.isObject(newVal) && _.isObject(oldVal)) {
      const nested = getAddedOnly(newVal, oldVal);
      if (nested && Object.keys(nested).length > 0) {
        result[key] = nested;
      }
    }
  }

  return Object.keys(result).length ? result : undefined;
};

const removeObjs = (currentItems, previousItems) => {
  const _previousItems = _.cloneDeep(previousItems)
  _.forEach(_previousItems, (pi, piKey) => {
    if (!currentItems[piKey]) {
      delete _previousItems[piKey]
    }
  })
  return _previousItems
}

const deepPick = (existing, newObj) => {
  // Create a new object where only the keys present in newObj will be retained
  return _.reduce(existing, (result, value, key) => {
    // If the key exists in the new object, recursively call deepPick for nested objects
    if (_.has(newObj, key)) {
      // If the value is an object and not an array, recurse, otherwise keep the value
      result[key] = _.isObject(value) && !_.isArray(value)
        ? deepPick(value, newObj[key])
        : value;
    }
    return result;
  }, {});
};


const findMatchingItem = (dataCollectionItem, appDataDocument) => {
  const entry = _.find(_.entries(appDataDocument), ([key, item]) => {
    const hasFullName = !_.isEmpty(dataCollectionItem.firstName) && !_.isEmpty(dataCollectionItem.lastName);

    if (hasFullName) {
      return item.firstName === dataCollectionItem.firstName && item.lastName === dataCollectionItem.lastName;
    }

    return item.name === dataCollectionItem.name;
  });

  // If a matching item is found, add the _itemKey property and return it
  return entry ? { ...entry[1], _itemKey: entry[0] } : null;
};

const getPreviewSettings = (projectSettings_gs, gvviSettings, fromCreate) => {

  const { global, viewItems, views } = projectSettings_gs ?? {} // coming from gooogle sheets
  const { aps_global, aps_views, aps_viewItems, aps_appUserSettings } = gvviSettings ?? {} // coming from app

  const _deletedItems = {
    views: [],
    props: [],
    propSections: []
  }

  // at this point, any added connections are not there
  const settings_adjusted = {
    global: fromCreate ? global : mergeObjs(global, aps_global),
    viewItems: viewItems ? fromCreate ? viewItems : mergeObjs(viewItems, aps_viewItems, fromCreate) : aps_viewItems,
    views: views ? fromCreate ? views : mergeObjs(views, aps_views, fromCreate) : aps_views,
    viewItems_alt: mergeObjz(viewItems, aps_viewItems),
    views_alt: mergeObjz(views, aps_views)
  }

  const settings_adjusted_gs_app = {
    global: fromCreate ? global : mergeObjs(global, aps_global),
    viewItems: viewItems ? fromCreate ? viewItems : mergeObjs(viewItems, aps_viewItems) : aps_viewItems,
    views: views ? fromCreate ? views : mergeObjs(views, aps_views) : aps_views,
    viewItems_alt: mergeObjz(viewItems, aps_viewItems),
    views_alt: mergeObjz(views, aps_views)
  }

  const settings_adjusted_app_gs = {
    global: fromCreate ? global : mergeObjs(global, aps_global),
    viewItems: viewItems ? fromCreate ? viewItems : mergeObjs(aps_viewItems, viewItems) : aps_viewItems,
    views: views ? fromCreate ? views : mergeObjs(aps_views, views) : aps_views,
    viewItems_alt: mergeObjz(aps_viewItems, viewItems),
    views_alt: mergeObjz(aps_views, views)
  }

  removeNonExistingPropsAndPropSections(settings_adjusted.viewItems, viewItems, _deletedItems)

  // loop the views
  _.forEach(settings_adjusted.views, (vw_m, vwKey) => {
    const vw_o = views ? views[vwKey] : {}
    const { viewItems: viewItems_m } = vw_m ?? {}
    const { viewItems: viewItems_o } = vw_o ?? {}
    removeNonExistingPropsAndPropSections(viewItems_m, viewItems_o, _deletedItems)
  })

  _.forEach(settings_adjusted_gs_app.views, (vw_m, vwKey) => {
    const vw_o = views ? views[vwKey] : {}
    const { viewItems: viewItems_m } = vw_m ?? {}
    const { viewItems: viewItems_o } = vw_o ?? {}
    removeNonExistingPropsAndPropSections(viewItems_m, viewItems_o, _deletedItems)
  })

  _.forEach(settings_adjusted_app_gs.views, (vw_m, vwKey) => {
    const vw_o = views ? views[vwKey] : {}
    const { viewItems: viewItems_m } = vw_m ?? {}
    const { viewItems: viewItems_o } = vw_o ?? {}
    removeNonExistingPropsAndPropSections(viewItems_m, viewItems_o, _deletedItems)
  })

  // const _vis = dataFix.ammendOmits(vis, _deleteViProps)

  const previewSettings = {
    global: settings_adjusted.global,
    viewItems: settings_adjusted.viewItems,
    views: settings_adjusted.views,
    viewItems_alt: settings_adjusted.viewItems_alt,
    views_alt: settings_adjusted.views_alt
  }

  const previewSettings_gs_app = {
    global: settings_adjusted_gs_app.global,
    viewItems: settings_adjusted_gs_app.viewItems,
    views: settings_adjusted_gs_app.views,
    viewItems_alt: settings_adjusted_gs_app.viewItems_alt,
    views_alt: settings_adjusted_gs_app.views_alt
  }

  const previewSettings_app_gs = {
    // global: settings_adjusted_app_gs.global,
    // viewItems: settings_adjusted_app_gs.viewItems,
    // views: settings_adjusted_app_gs.views,
    viewItems_alt: settings_adjusted_app_gs.viewItems_alt,
    views_alt: settings_adjusted_app_gs.views_alt
  }

  return { previewSettings, previewSettings_gs_app, previewSettings_app_gs }

}

const getPreviousPreviewInfo = (googleSheetsPreview, previousEventSettings, state) => {

  let { global: global_previous, viewItems: viewItems_previous, views: views_previous } = previousEventSettings ?? {}
  const { projectOptions: projectOptions_previous, themeColors: themeColors_previous } = global_previous ?? {}
  const { gsid } = state

  const _previewInfo = { ...googleSheetsPreview }
  const { projectSettings, projectData } = _previewInfo ?? {}
  const { eventData } = projectData ?? {}

  const { global: global_current, viewItems: viewItems_current, views: views_current } = projectSettings ?? {}

  _previewInfo.projectSettings.global = global_previous

  viewItems_previous = removeObjs(viewItems_current, viewItems_previous)
  views_previous = removeObjs(views_current, views_previous)
  viewItems_previous = deepPick(viewItems_previous, viewItems_current)
  views_previous = deepPick(views_previous, views_current)

  // merge the objects
  _previewInfo.projectSettings.viewItems = mergeObjs(viewItems_current, viewItems_previous, _inverseMerge)
  _previewInfo.projectSettings.views = mergeObjs(views_current, views_previous, _inverseMerge)
  _previewInfo.projectSettings.global.topMenu = _.merge({}, global_previous.topMenu, global_current.topMenu);

  if (_overrideProps) {
    ammendPropsAndSections(_previewInfo.projectSettings.viewItems, viewItems_previous)
    ammendPropsAndSections(_previewInfo.projectSettings.views, views_previous)
  }

  _previewInfo.projectSettings.global.googleSheets = global_current.googleSheets

  if (global_current.banner) { _previewInfo.projectSettings.global.banner = global_current.banner }
  if (global_current.homePage) { _previewInfo.projectSettings.global.homePage = global_current.homePage }

  delete _previewInfo.projectSettings.global._itemKey
  delete _previewInfo.projectSettings.global.id
  delete _previewInfo.projectSettings.views._itemKey
  delete _previewInfo.projectSettings.views.id
  delete _previewInfo.projectSettings.viewItems._itemKey
  delete _previewInfo.projectSettings.viewItems.id

  _previewInfo.projectSettings.global = dataFix.removeAllEmpties(_previewInfo.projectSettings.global)

  // if (eventData && eventData.name) {
  //   _previewInfo.projectSettings.global.topMenu.mainFixedCaption = eventData.name
  // }

  if (gsid) {
    _previewInfo.projectSettings.global.googleSheets.googleSheetsId = gsid
  }

  return {
    googleSheetsPreview: _previewInfo,
    themeColors: themeColors_previous,
    projectOptions: projectOptions_previous
  }
}

// const getMergedDataCollections = (appDataDocuments, dataCollections) => {
//   const _dataCollections = dataCollections ? _.cloneDeep(dataCollections) : {};
//   const _dataCollections_m = {};

//   if (appDataDocuments) {
//     _.forEach(appDataDocuments, (appDataDocument, dcKey) => {
//       _dataCollections_m[dcKey] = {};

//       // Ensure we iterate over appDataDocuments first
//       _.forEach(appDataDocument, (appDataDocumentItem, appDocKey) => {
//         _dataCollections_m[dcKey][appDocKey] = appDataDocumentItem;
//       });

//       // Merge dataCollections items where they exist
//       if (_dataCollections[dcKey]) {
//         _.forEach(_dataCollections[dcKey], (dataCollectionItem, dciKey) => {
//           const match = findMatchingItem(dataCollectionItem, appDataDocument);
//           const itemKey = match ? match._itemKey : dciKey;

//           _dataCollections_m[dcKey][itemKey] = _.merge(
//             {},
//             _dataCollections_m[dcKey][itemKey] || {},
//             dataCollectionItem,
//             match || {}
//           );
//         });
//       }
//     });
//   }

//   return _dataCollections_m;
// };


const getMergedDataCollections = (appDataDocuments, dataCollections) => {

  const _dataCollections = dataCollections ? _.cloneDeep(dataCollections) : {}
  const _dataCollections_m = {}

  if (appDataDocuments) {

    _.forEach(_dataCollections, (dataCollection, dcKey) => {
      _dataCollections_m[dcKey] = {}
      if (appDataDocuments[dcKey]) {

        const appDataDocument = appDataDocuments[dcKey]

        _.forEach(dataCollection, (dataCollectionItem, dciKey) => {
          const appDataDocument_match = findMatchingItem(dataCollectionItem, appDataDocument)
          if (appDataDocument_match) {
            _dataCollections_m[dcKey][appDataDocument_match._itemKey] = _.merge({}, appDataDocument_match, dataCollectionItem);
          } else {
            _dataCollections_m[dcKey][dciKey] = dataCollectionItem
          }
        })

        // if (dcKey === 'sessions') {
        //   const sss = _dataCollections_m?.sessions
        //   _.forEach(appDataDocument, (appDataDocumentItem, addKey) => {
        //     const dataCollectionItem = dataCollection[addKey]
        //     if (dataCollectionItem) {
        //       appDataDocumentItem.attendees = dataCollectionItem.attendees
        //     } else {
        //       delete appDataDocumentItem.attendees
        //     }
        //     _dataCollections_m[dcKey][addKey] = appDataDocumentItem
        //   })
        // }
        //else {
        //   _.forEach(dataCollection, (dataCollectionItem, dciKey) => {
        //     const appDataDocument_match = findMatchingItem(dataCollectionItem, appDataDocument)
        //     if (appDataDocument_match) { 
        //       _dataCollections_m[dcKey][appDataDocument_match._itemKey] = _.merge({}, appDataDocument_match, dataCollectionItem);
        //     } else {
        //       _dataCollections_m[dcKey][dciKey] = dataCollectionItem
        //     }
        //   })
        // }
      }
    })
  }

  return _dataCollections_m

}

/**
 * 
 * @param {*} appDataDocuments 
 * @param {*} googleSheetsPreview 
 * @param {*} pageSettings_app 
 * @param {*} staticViews_app 
 * @param {*} globalOnly 
 * @param {*} forUpdate 
 * @param {*} newIsPriority 
 * @returns projectSettings, projectData
 */
const getMergedSettings = (appDataDocuments, googleSheetsPreview, gvviSettings, staticViews_app, globalOnly, forUpdate, newIsPriority) => {

  const { aps_viewItems, aps_views } = gvviSettings
  const { projectSettings: projectSettings_preview, projectData } = googleSheetsPreview ?? {}
  const { dataCollections } = projectData ?? {}
  const _dataCollections = dataCollections ? _.cloneDeep(dataCollections) : {}
  const { global: global_preview, viewItems: viewItems_preview, views: views_preview } = projectSettings_preview ?? {}

  const _dataCollections_m = getMergedDataCollections(appDataDocuments, _dataCollections)

  let _projectSettings = {}

  if (globalOnly) {
    _projectSettings = {
      viewItems: viewItems_preview,
      views: views_preview,
    }
  } else {

    const vis = mergeObjs(viewItems_preview, aps_viewItems, _inverseMerge)
    const vws = mergeObjs(views_preview, aps_views, _inverseMerge)

    if (_overrideProps) {
      ammendPropsAndSections(vis, viewItems_preview)
      ammendPropsAndSections(vws, views_preview)
    }

    _projectSettings = {
      global: global_preview,
      viewItems: vis,
      views: vws,
    }
  }
  if (forUpdate && _dataCollections && viewItems_preview && staticViews_app) {
    Object.keys(viewItems_preview).forEach(key => {
      if (staticViews_app[key]) {
        delete _dataCollections[key]
      }
    })
  }

  const _projectData = {
    dataCollections: appDataDocuments ? _dataCollections_m : _dataCollections
  }

  return { projectSettings: _projectSettings, projectData: _projectData }
}

const ammendPropsAndSections = (merged, original) => {
  Object.keys(merged).forEach(k => {
    const _vim = merged[k]
    const _vio = original[k]
    const { viewItems: viewItems_m } = _vim
    const { props, propSections, viewItems: viewItems_o } = _vio

    if (props) { _vim.props = props }
    if (propSections) { _vim.propSections = propSections }

    if (viewItems_m) {
      Object.keys(viewItems_m).forEach(vik => {
        const viewItem_m = viewItems_m[vik]
        const viewItem_o = viewItems_o ? viewItems_o[vik] : null
        if (viewItem_m && viewItem_o) {
          const { props: props_o, propSections: propSections_o } = viewItem_o
          if (props_o && Object.keys(props_o).length > 0) { viewItem_m.props = props_o }
          if (propSections_o && Object.keys(propSections_o).length > 0) { viewItem_m.propSections = propSections_o }
        }
      })
    }
  })
}

const removeNonExistingPropsAndPropSections = (viewItems_merged, viewItems, deletedItems) => {
  if (!viewItems_merged || !viewItems) return;

  _.forEach(viewItems_merged, (vi_m, viKey) => {
    const vi = viewItems[viKey] || {};
    const props_m = vi_m?.props || {};
    const propSections_m = vi_m?.propSections || {};
    const propKeys = new Set(_.keys(vi.props));
    const propSectionKeys = new Set(_.keys(vi.propSections));

    _.forEach(props_m, (__, prmKey) => {
      if (!propKeys.has(prmKey)) {
        deletedItems.props.push({ viKey, prmKey });
        delete props_m[prmKey];
      }
    });

    _.forEach(propSections_m, (__, psKey) => {
      if (!propSectionKeys.has(psKey)) {
        deletedItems.propSections.push({ viKey, psKey });
        delete propSections_m[psKey];
      }
    });
  });
};

const getUniqueValues = (database_fns, mainObject, searchProp, propObjName) => {
  const nvs = _.uniq(
    _.flatMap(mainObject, (collection) =>
      _.map(collection, searchProp)
    ).filter((v) => v != null && v !== '') // skip null and empty string
  );

  const nvo = {}
  _.forEach(nvs, (nv) => {
    nvo[database_fns.get_docKey(true)] = {
      name: nv
    }
  })
  const _nvo = {
    [propObjName]: nvo
  }
  return { newArray: nvo, newObject: _nvo }
};

const collectTypeProps = (mainObject) => {
  const newProps = {};

  const traverse = (obj) => {
    if (!_.isObject(obj)) return;

    _.forOwn(obj, (value, key) => {
      if (/type$/i.test(key)) {
        // Ensure array exists for this prop key
        if (!newProps[key]) newProps[key] = [];

        if (_.isArray(value)) {
          value.forEach(v => {
            if (v != null && v !== '') {
              newProps[key].push({ name: v });
            }
          });
        } else {
          if (value != null && value !== '') {
            newProps[key].push({ name: value });
          }
        }

        // Deduplicate by the "name" property
        newProps[key] = _.uniqBy(newProps[key], 'name');
      }

      // Keep traversing
      if (_.isObject(value)) {
        traverse(value);
      }
    });
  };

  traverse(mainObject);
  return newProps;
};

const normalizeTypeFields = (data, fieldNames) => {
  // Extract the pluralized keys we care about
  const targetProps = _.map(fieldNames, '_propKey'); // e.g., ['eventTypes', 'sessionTypes', ...]

  const recurse = (obj) => {
    return _.mapValues(obj, (value, key) => {
      if (_.isPlainObject(value)) {
        return recurse(value); // go deeper into objects
      }
      if (
        targetProps.includes(key) && // key matches one of the collected props
        !_.isArray(value)             // not already an array
      ) {
        return [value];
      }
      return value;
    });
  };

  const newValues = recurse(data);

  return newValues;
};


const collectTypeFields = (mainObject, matchingArrays = []) => {
  const fieldNames = {};

  _.forEach(mainObject, (b) => {
    _.forEach(b, (c) => {
      _.forEach(c, (d, dk) => {
        _.forEach(matchingArrays, (match) => {
          const regex = new RegExp(`${match}$`, 'i'); // match at the end of key
          if (regex.test(dk)) {
            const _dk = dk.replace(match, _.startCase(match))
            const _d = _.camelCase(_dk) + 's';
            fieldNames[_dk] = {
              label: _.startCase(_d),
              caption: _.startCase(_d),
              _propKey: _d,
            };
          }
        });
      });
    });
  });

  return fieldNames;
};

function renamePropsInMainObject(mainObj, existingProps, newProps) {
  _.forEach(mainObj, (collection) => {
    _.forEach(collection, (item) => {
      _.forEach(existingProps, (oldProp, index) => {
        const newProp = newProps[index];
        if (_.has(item, oldProp)) {
          item[newProp] = item[oldProp];
          delete item[oldProp];
        }
      });
    });
  });
  return mainObj;
}

/**
 * Converts name arrays to key arrays ['Name1', 'Name2'] => ['nameKey1', 'nameKey2']
 * @param {*} mainObj 
 * @returns 
 */
function convertArrayNamesToKeys(mainObj) {
  _.forEach(mainObj, (collection, collectionKey) => {
    _.forEach(collection, (item) => {
      _.forEach(item, (value, fieldKey) => {
        // Check if the field name matches a top-level key and is an array
        if (_.has(mainObj, fieldKey) && _.isArray(value)) {

          const fieldObj = mainObj[fieldKey];

          // Create a map of name → key for quick lookup
          const nameToKey = _.transform(fieldObj, (result, obj, objKey) => {
            if (_.has(obj, 'name')) {
              result[obj.name] = objKey;
            }
          }, {});

          // Replace array values if matching name found
          item[fieldKey] = _.map(value, val => nameToKey[val] || val);
        }
      });
    });
  });

  return mainObj;
}


const convertTypeKeys = (mainObject, fieldNames) => {
  const traverse = (o) => {
    if (!_.isObject(o)) return;

    _.forOwn(o, (value, key) => {
      if (fieldNames[key]) {
        const newKey = fieldNames[key]._propKey;
        o[newKey] = value;
        delete o[key];
        traverse(o[newKey]);
      } else {
        traverse(value);
      }
    });
  };

  // Start traversing from the top-level categories
  _.forOwn(mainObject, (categoryObj) => {
    traverse(categoryObj);
  });

  return mainObject; // mutates in place
};

const findByKey = (fieldNames, targetKey) => {
  let result;

  const search = (_fieldNames) => {
    if (!_.isObject(_fieldNames)) return;

    _.forEach(_fieldNames, (fieldName, fieldNameKey) => {
      if (fieldNameKey.toLowerCase() === targetKey.toLowerCase() || fieldName?._fieldNameKey?.toLowerCase() === targetKey.toLowerCase()) {
        result = fieldName;
        return false; // stop iteration
      }
      search(fieldName);
    });
  };

  search(fieldNames);
  return result;
};

const toBoolean = v => _.isString(v)
  ? v.toLowerCase() === 'yes'
  : Boolean(v);